
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/en/claims",
      function () {
        return require("private-next-pages/fr/en/claims.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/en/claims"])
      });
    }
  